/**
 * Centralized configuration for the Connect-4 application.
 * All environment-specific settings (URLs, ICE servers, etc.) go here.
 */

const IS_PROD = process.env.NODE_ENV === 'production';

export const APP_BASE_URL = process.env.REACT_APP_BASE_URL || (IS_PROD ? 'https://connect-4-gamma-lake.vercel.app' : 'http://localhost:3000');

export const CONFIG = {
  // Socket.io Server URL
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || (IS_PROD ? 'https://openleague.up.railway.app' : 'http://localhost:3001'),
  
  // API Base URL
  API_URL: process.env.REACT_APP_API_URL || (IS_PROD ? 'https://openleague.up.railway.app/api' : 'http://localhost:3001/api'),

  // WebRTC ICE Servers (STUN/TURN)
  // To use a TURN server (recommended for production mobile use), 
  // add it to this array: { urls: 'turn:your-turn-server.com', username: '...', credential: '...' }
  ICE_SERVERS: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
  ],

  // Game Settings
  DEFAULT_TIMER: 15, // Matching the server authoritative timer
};

export default CONFIG;
